 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "vendors." + {"0":"b9914cb945b4a0c2d80e","1":"bc366bc0f7cc240e499c","2":"f43fa696b43569b800d2","3":"6daa59b1d8212b2ac9d5","4":"a0cb0870f4554bdb2844","5":"ea3e394bf34592cf26f4","6":"b9f9cf1fca6620075df7","AccountOpening":"d63b39b7a5555c6dadc8","BackTopBottom":"7918b582b582d0533432","Caption":"98617f01ca61abd74155","Copyright":"1c46097e99ba984035fd","DataBox":"94b2de02c7e4bd0dac37","HomeFooter":"00fee57e5e029f58886a","LivePlayer":"39a1ca2ef22bb859da22","MoreTabs":"423d0b983e5975e85f76","Nav":"7ebcb297f49261dd0a61","NormalCaption":"1b2aa96498c08cfc588c","Offline":"07019b700b8ae3e12ae9","Tip":"71c083a31eb512e3d760","ViewMoreLink":"df37b9a2b311d1eeb6b8","WxLaunchApp":"f0ff9810ce08a05840ad","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"5c7abf3b154cb5a97788","Atlas":"b83c946cd67c85aa3e86","FiveNavPic":"8168c2ae84ea4a0520c9","FourNavPic":"026803f904a7784fa9be","ThreeNavPic":"dc4c701b4bbd5313ddda","vendors~BigImage~Hongbao~NewsStream~NoImage~OneImage~Survey~ThreeImage~TwoImage":"c0b106b6e9249649c2a1","vendors~BigImage~NewsStream~NoImage~OneImage~Stick~ThreeImage~TwoImage":"27282af0fbe0cae1dc0d","BigImage":"02c6951ff06e341d3a44","NoImage":"95ca1079cd40c4babb1e","OneImage":"b77999ee2876f9a71861","TwoImage":"67a9960116462f4680f1","vendors~NewsStream~ThreeImage":"15530176667fb0b9fdf2","vendors~NewsStream":"435d1aaf34e9eefa6848","vendors~Hongbao":"d5ae083f1a2e71be8133","Stick":"d77817b381f1ca9bd9a3","vendors~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~IndexSlides~InformationFlow~MarkTa~bbbc43f7":"f22d981f53fcf552e743","BrowserGuideLayer":"6adb186f060290c999d9","MarkTabs":"4a81d524d2c7fb574898","PageBottomBrand":"431fbf56973b6f22365c","vendors~MdBanner":"5bbf741e19e468092fcb","vendors~Survey":"e7643acff7d78833abe8","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"74563cdb2c96b8721de7","SingleTitle":"bb1129187f27481fd6f6","SlideImg":"903ebcc4e569316dadba","TwoImg":"2e32e48d76802f10d707","vendors~BigTopic~InformationFlow~TitleImg":"dc9912c173d8f0da85dc","InformationFlow":"dfa038c76c965524525b","vendors~BigImg":"3640cccec27160ee0932","BigImg":"a6c40e57c8822972d4c0","TitleImg":"b3d39b13d7eb0162436a","vendors~BigTopic":"7eeedbed27b5e3ce63a8","BigTopic":"ccea1750560c1dec3710","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"32c24a21add6786b0038","vendors~BottomSlides~UpgradeBottomSlides":"ca139d6522f1e553781b","UpgradeBottomSlides":"e51f11f73bef8209d5db","vendors~IndexSlides":"3bc9a98cbb2d2c3f045c","vendors~CallupHead":"49805255ce42ef49607f","vendors~Comment~ShareComment":"300457be80cf0bd9919e","vendors~ShareComment":"d8cac7c0e8ae6c6eae27","vendors~Player":"8c7b96d57823ea6d527d","vendors~WXGuideLayer":"6a7a027a28d51c300052","vendors~WxLaunchHack":"5cd3a2106990db6a5eef","Slides":"4c603e7444a49d289583","vendors~NormalSlides":"cb8d31b71d9866e0bd81","vendors~ShareSlides":"71cbbcfd63d8964b63de","vendors~CallupVideoAppHead":"671c81600bf808f222dc","vendors~Comment~LoginDialog":"9142d8da1b221cdea634","LoginDialog":"da7b9f0dbcb47419d4a8","vendors~Comment":"fad8bb84bebc840f116c","Comment":"dbbc33a4307d2ef084c5","vendors~Img":"3854d980dd12fb3887a5","vendors~NormalTabs":"a4d16ba830526c8c5dda","vendors~QQShare":"2f002b31cac6c2ea7eb4","vendors~SimpleGuideLayer":"032a1d59aa8f59115e12","vendors~SlidesTabs":"3ae7f0aa2bce50bb6448","vendors~pics":"e76f2f81dc63d1c5949b","pics":"68af26c55822023a23f4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x2.ifengimg.com/fe/shank/content/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
